import React from 'react';
import { ErrorOutlineIcon } from '@move-ui/icons-asset-catalog';
import Text, { TextSize } from '@move-ui/text';
import styles from './ErrorMessage.module.css';
export const ErrorMessage = ({ id, message }) => (React.createElement("div", { id: id, className: styles.errorMessage },
    React.createElement(ErrorOutlineIcon, { className: styles.errorIcon }),
    React.createElement(Text, { size: TextSize.XXS, color: "emotion-200" }, message)));
//# sourceMappingURL=ErrorMessage.js.map